export interface Progress {
  [unit: string]: {
    [module: string]: Date
  }
}

const PROGRESS_KEY = "progress"

export const getModuleProgress = (): Progress | null => {
  const data = localStorage.getItem(PROGRESS_KEY)
  if (!data) return null
  const progress = JSON.parse(data)
  return progress
}

export const saveModuleProgress = (unit: string, module: string): Progress | null => {
  let progress = getModuleProgress()
  if (!progress) {
    progress = {}
  }

  if (!progress[unit]) {
    progress[unit] = {}
  }

  progress[unit][module] = new Date()
  localStorage.setItem(PROGRESS_KEY, JSON.stringify(progress))
  return progress
}

export const resetProgress = () => {
  localStorage.removeItem(PROGRESS_KEY)
}
